var Backbone = require('backbone');

var Collection = new Backbone.Collection();


var update = function() {
	$.ajax({
		url: 'api/index.php',
		type: 'post',
		dataType: 'json',
		data: {
			query: 'query { kits { id tipo titulo ativo imagem editavel valor valor_promocional promocao filtros { id imagem titulo ativo } refeicoes { dia porcoes {         calorias valor valor_promocional produto { ativo promocao } } } porcoes { calorias valor valor_promocional produto { ativo promocao } } } }'
		},
		success: function(resp) {
			var data = resp.data;
			var kits = data.kits.filter(function(kit) {
				if (!kit.ativo) return false;

				if (kit.tipo == 'Kit') {
					var porcoes = kit.porcoes.filter(function(porcao){
						if (porcao.produto.ativo) return true;
						return false;
					});
					return porcoes.length == 0 ? false : true;
				} else {						
					var refeicoes = kit.refeicoes.filter(function(refeicao) {
						if (0 == refeicao.porcoes.length) return false;
						var porcoes = refeicao.porcoes.filter(function(porcao){
							if (porcao.produto.ativo) return true;
							return false;
						});
						return porcoes.length == 0 ? false : true;
					});

					return refeicoes.length == 0 ? false : true;
				}
			});

			var kits = kits.map(function(kit) {
				kit.filtros = kit.filtros.filter(function(filtro) {
					return filtro.ativo;
				});

				if (kit.tipo == 'Kit') {
					kit.produtos_inativos = kit.porcoes.reduce(function(qtd, porcao) {
						if (!porcao.produto.ativo) {
							return qtd + 1;
						};
						return qtd;
					},0);
					kit.produtos = kit.porcoes.filter(function(porcao) {
						return porcao.produto.ativo;
					});
					kit.dias = 1;
				} else {
					kit.produtos_inativos = 0;
					kit.produtos = kit.refeicoes.reduce(function(porcoes, refeicao) {
						refeicao.porcoes.forEach(function(porcao) {
							if (porcao.produto.ativo) {
								porcoes.push(porcao);
							} else {
								kit.produtos_inativos++;
							}
						});
						return porcoes;
					}, []);
					kit.dias = kit.refeicoes.reduce(function(dias, refeicao) {
						if (dias.indexOf(refeicao.dia) == -1) {
							dias.push(refeicao.dia);
						}
						return dias;
					},[]).length;
				}

				kit.calorias = kit.produtos.reduce(function(calorias, porcao) {
					return porcao.calorias+calorias;
				}, 0.0)/kit.dias;

				if (kit.editavel) {
					kit.valor = kit.produtos.reduce(function(valor, porcao) {
						return porcao.valor + valor;
					}, 0.0);
					kit.valor_promocional = kit.produtos.reduce(function(valor, porcao) {
						var valor_promocional = porcao.produto.promocao ? porcao.valor_promocional : porcao.valor;
						return valor_promocional + valor;
					}, 0.0);
				} else if (!kit.editavel && kit.valor_promocional == 0.0) {
					kit.valor_promocional = kit.valor;
				}

				kit.calorias = Math.round(kit.calorias);
				kit.valor = kit.valor.toFixed(2)*1.0;
				kit.valor_promocional = kit.valor_promocional.toFixed(2)*1.0;
				delete kit.produtos;
				//delete kit.porcoes;
				delete kit.refeicoes;

				return kit;
			}).filter(function(kit){
				return kit.produtos_inativos == 0;
			});

			Collection.set(kits);
		},
		error: function() {
			console.log("Não foi possível carregar os kits");
		}
	});
};

update();

module.exports = Collection;


//////////////////
// WEBPACK FOOTER
// ./collections/kits.js
// module id = 7
// module chunks = 0